import { render, staticRenderFns } from "./commodities.html?vue&type=template&id=25d032e8&scoped=true&"
import script from "./commodities.ts?vue&type=script&lang=js&"
export * from "./commodities.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d032e8",
  null
  
)

export default component.exports